import * as actionType from "../Actions/Action_Type";
import * as ROLES from "../Utils/Roles_Types.js";
import { LABEL_Delete  } from "../Utils/Strings/Labels";

const campoColDelete = {
    TipoCampo : {ID: -1},
    Nome : " "
}

const initialState = {
    isFetching              : false,
    campiPersonalizzatiList : [],
    tabelleList             : [],
    addModifyCampiList      : [],
    toRefreshOnRender       : false,
    errorMessage            : null,
    isAuthenticated         : false,
    holdingList             : [],
    fillTableOpen           : false,
    campiPersonalizzatiCol  : [],
    campiTabellaList        : [],
    campiTabellaModifyIndexes : [],
    tableColumnValues       : []
};

const campiPersonalizzatiReducer = (state = initialState, action) => {
    switch (action.type){
        case actionType.SERVICE_CAMPIPERSONALIZZATI_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_CAMPIPERSONALIZZATI_LIST_SUCCESS :
            state.campiPersonalizzatiCol = JSON.parse(JSON.stringify(action.response));
            state.campiPersonalizzatiCol.unshift(campoColDelete);
            return Object.assign({}, state, {
                isFetching               : false,
                campiPersonalizzatiList  : action.response,
                campiPersonalizzatiCol   : state.campiPersonalizzatiCol,
                authenticated            : action.authenticated || false,
                toRefreshOnRender        : false
            })
        case actionType.SERVICE_CAMPIPERSONALIZZATI_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : action.error || null
            })
        case actionType.SERVICE_CAMPIPERSONALIZZATI_REFRESH_LIST :
            state.campiPersonalizzatiCol = JSON.parse(JSON.stringify(action.newList));
            state.campiPersonalizzatiCol.unshift(campoColDelete);
            return Object.assign({}, state, {
                isFetching               : false,
                campiPersonalizzatiList  : action.newList,
                campiPersonalizzatiCol   : state.campiPersonalizzatiCol,
            })
        //SET CAMPO
        case actionType.SERVICE_CAMPIPERSONALIZZATI_SET_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_CAMPIPERSONALIZZATI_SET_SUCCESS :
            return Object.assign({}, state, {
                isFetching               : false,
                authenticated            : action.authenticated || false,
                toRefreshOnRender        : true
            })
        case actionType.SERVICE_CAMPIPERSONALIZZATI_SET_ERROR :
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : action.error || null
            })    
        //HOLDING LIST
        case actionType.SERVICE_HOLDING_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_HOLDING_LIST_SUCCESS :
            return Object.assign({}, state, {
              isFetching  : false,
              holdingList : action.response 
            });
        case actionType.SERVICE_HOLDING_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching: false
            })
        //RECUPERO I DATI DELL'UTENTE
        case actionType.SERVICE_USERINFO_REQUEST :
        return Object.assign({}, state, {
            isFetching : true,
        })
        case actionType.SERVICE_USERINFO_SUCCESS :
        var response = action.response;
        //salvo i dati dell'utente
        if(response.hasOwnProperty("IDUser") && response.hasOwnProperty("Username") && response.hasOwnProperty("Role")){
            localStorage.setItem(ROLES.USERINFO_KEY, JSON.stringify(response));
            return Object.assign({}, state, {
            isFetching      : false,
            isAuthenticated : action.authenticated || false,
            userInfo        : response
            })
        }else{
            return Object.assign({}, state, {
            isFetching      : false,
            isAuthenticated : false,
            userInfo        : null
            })
        }
        case actionType.SERVICE_USERINFO_ERROR :
        return Object.assign({}, state, {
            isFetching: false,
            errorMessage: action.error || null,
            isAuthenticated: false
        });
        //LISTA DELLE TABELLE
        case actionType.SERVICE_TABELLE_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_TABELLE_LIST_SUCCESS :
            return Object.assign({}, state, {
                isFetching        : false,
                tabelleList       : typeof action.response === 'undefined' ? [] : action.response,
                authenticated     : action.authenticated || false,
                toRefreshOnRender : false,
                errorMessage      : null
            })
        case actionType.SERVICE_TABELLE_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching   : false,
                errorMessage : action.error || null
            })
        //LISTA CAMPI PERSONALIZZATI PER DIALOG ADDMODIFY
        case actionType.SERVICE_CAMPITABELLA_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_CAMPITABELLA_LIST_SUCCESS :
            return Object.assign({}, state, {
                isFetching               : false,
                addModifyCampiList       : action.response,
                authenticated            : action.authenticated || false,
            })
        case actionType.SERVICE_CAMPITABELLA_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : action.error || null
            })
        //RECUPERO LA LISTA DEI VALORI PER COLONNA
        case actionType.SERVICE_TABELLE_GET_COLUMN_VALUES_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_TABELLE_GET_COLUMN_VALUES_SUCCESS :
            return Object.assign({}, state, {
                isFetching        : false,
                authenticated     : action.authenticated || false,
                tableColumnValues : action.response
            })
        case actionType.SERVICE_TABELLE_GET_COLUMN_VALUES_ERROR :
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : action.error || null
            })
        //GESTISCO LA COMPILAIZONE TABELLA
        case actionType.SERVICE_TABELLE_GET_VALUES_REQUEST :
            return Object.assign({}, state, {
                isFetching: true,
                fillTableOpen : false
            })
        case actionType.SERVICE_TABELLE_GET_VALUES_SUCCESS :
            //Creo la tabella html
            // Recupero il numero massimo di righe
            return Object.assign({}, state, {
              isFetching  : false,
              campiTabellaList : action.response,
              fillTableOpen : true
            });
        case actionType.SERVICE_TABELLE_GET_VALUES_ERROR :
            return Object.assign({}, state, {
                isFetching: false,
                fillTableOpen : false
            })
        case actionType.SERVICE_TABELLE_CLOSE_FILL_TABLE :
            return Object.assign({}, state, {
                fillTableOpen : false,
                isFetching  : false,
            })
        // DELETE ROWS
        case actionType.SERVICE_TABELLE_REFRESH_TABLEVALUE : 
            let checkIndex = val => { if(state.campiTabellaModifyIndexes.indexOf(action.index)) state.campiTabellaModifyIndexes.push(action.index); };
            if(Array.isArray(action.index)){
                action.index.forEach( item => checkIndex(item) );
            }else
                checkIndex(action.index);
            console.log("reducer", action);
            return Object.assign({}, state, {
                    campiTabellaList          : action.newList,
                    campiTabellaModifyIndexes : state.campiTabellaModifyIndexes
                })
        default:
            return state;
    }
};

export default campiPersonalizzatiReducer;


// WEBPACK FOOTER //
// ./src/Reducers/Reducer_Campi.js